"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var makeThankYouBannerStyling_1 = __importDefault(require("./makeThankYouBannerStyling"));
var CelebrationIcon_1 = __importDefault(require("./icons/CelebrationIcon"));
var ThankYouBanner = function (_a) {
    var brandLogo = _a.brandLogo, children = _a.children;
    var styles = (0, makeThankYouBannerStyling_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [brandLogo && (0, jsx_runtime_1.jsx)("div", { css: styles.brandLogo, children: brandLogo }), (0, jsx_runtime_1.jsxs)("div", { css: styles.thankYouBanner, children: [(0, jsx_runtime_1.jsx)(CelebrationIcon_1.default, {}), children] })] }));
};
exports.default = ThankYouBanner;
//# sourceMappingURL=ThankYouBanner.js.map